export enum FeedbackNegativeColorToken {
  feedbackColorNegativePure = '#D22F2D',
  feedbackColorNegativeLight = '#FFEBEE',
  feedbackColorNegativeMedium = '#C52926',
  feedbackColorNegativeDark = '#B61D1A',
}

export default FeedbackNegativeColorToken

export type TNegative =
  | 'feedbackColorNegativePure'
  | 'feedbackColorNegativeLight'
  | 'feedbackColorNegativeMedium'
  | 'feedbackColorNegativeDark'
